import { brandSpecificStaticText } from 'utils/staticText';
import { personalLoanCalculatorTranslations } from './base';

export const TRANSLATIONS = brandSpecificStaticText({
  _: personalLoanCalculatorTranslations,
  // Brand specific translations can be added here
});
